"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { useForm, Controller } from "react-hook-form";

export function AdminWithdrawalsFilter() {
  const searchParams = useSearchParams();
  const router = useRouter();

  const keyword = searchParams?.get(`keyword`) || "";

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ defaultValues: { keyword } });

  const onSubmit = async (data: any) => {
    let url = new URL(window.location.href);
    // if (isWithdrawal) url.searchParams.set("isWithdrawal", isWithdrawal);
    // if (role) url.searchParams.set("role", role);
    // if (provider) url.searchParams.set("provider", provider);
    url.searchParams.set("keyword", data.keyword);
    router.push(url.toString());
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div className="col-md-12 mb-4">
          <div className="input-group">
            <Controller
              control={control}
              name="keyword"
              render={({ field: { onChange, onBlur, value } }) => (
                <input
                  type="text"
                  id="keyword"
                  className="form-control form-control-md"
                  title="검색어(이름, 이메일, 휴대번화)를 입력해주세요."
                  placeholder="검색어(이름, 이메일, 휴대번화)를 입력해주세요."
                  value={value}
                  onBlur={onBlur}
                  onChange={onChange}
                />
              )}
            />
            <button className="btn btn-white btn-md" type="submit">
              <i className="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}
